<div class="flex bg-col-51 m-t-2 p-t-3 p-b-3 p-r-2 p-l-2">
    <div class="m-r-3">
        <div class="pos-relative ratio-1-1 w-12 overflow-hidden"
             style="width: 60px;">
            <local-shell />
            <img class="rf"
                 [image]="product?.data?.image">
        </div>
    </div>

    <div class="flex-grow">
        <div class="flex flex-justify-between flex-middle">
            <div class="flex flex-middle">
                <p class="p2 col-1">{{product?.name}}</p>
                <div class="w-5-s flex flex-middle">
                    <p class="p2 col-11 m-l-1 m-r-2">+{{currencySymbol}}{{product?.price}}</p>
                    <button type="button"
                            class="flex"
                            [iCmsModalOpen]="'protectionPlanInfoModal'"
                            [iCmsModalOpenData]="product">
                        <i class="icon-information inline-flex col-11"
                           aria-hidden="true"
                           style="font-size: 1.25rem"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="flex flex-justify-between flex-middle p-t-2">
            <p class="c1 col-12 m-t-1 p-r-2">{{product?.data?.short_description || ''}}</p>
            <action class="button-1"
                    [status]="status"
                    (click)="submit()"
                    cy-basketAddButton>
                {{'Add' | translate | uppercase }}
            </action>
            <result class="block"
                    [status]="status"></result>
        </div>
    </div>
</div>
